/**
 * @Author: shenyi
 * @Date:   2023-09-27 15:21:19
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-09-27 15:29:35
 */
import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/reset.css";
import getUrl from "./require";

Vue.config.productionTip = false;
getUrl().then((res) => {
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount("#app");
});
